import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthenticationService } from '../../core/services/auth.service';
import { environment } from 'src/environments/environment';
import { resetPasswordData, User } from 'src/app/modals/Authentication/auth.models';
import { AlertService } from 'src/app/core/services/alert.service';
import { RouterService } from 'src/app/core/services/router.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { LanguageService } from 'src/app/core/services/language.service';
import { avatarDeletion, avatarDeletionSuccess, avatarUpdate, avatarUpdateFailure, avatarUpdateSuccess, profileUpdate, profileUpdateFailure, profileUpdateSuccess } from './profile.actions';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class ProfileEffect {

  backend: string = environment.backend;

  profileUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(profileUpdate),
      exhaustMap( (data: any) => {

        const user = data.user;
        const url = "profile";
        return this.crudService.updateDataPost(url , user).pipe(
          map((response) => {
            this.alertService.triggerAlert(response.message, "success");
            const user = response.data;
            this.authenticationService.pushUserData(user);
            return profileUpdateSuccess({user: user});
          }),

          catchError((error) =>
            of(error).pipe(
              tap(() => {
                this.alertService.triggerAlert(error, "error");
              }),
              map(() => profileUpdateFailure({ error })) // Dispatch 
            )
          ),

          finalize(() => {
              this.helperService.formButtonDisabled = false;
          })
        );
      })
    )
  );


  avatarUpdate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(avatarUpdate),
      exhaustMap( (data: any) => {

        const url = "profile-avatar";
        let requestData: any;
        requestData = new FormData();
        requestData.append('avatar', data.avatar); // Add the file to FormData

        return this.crudService.addData(url, requestData).pipe(
          map((response) => {
            this.alertService.triggerAlert(response.message, "success");
            const user = response.data;
            this.authenticationService.pushUserData(user);
            return avatarUpdateSuccess({user: user});
          }),

          catchError((error) =>
            of(error).pipe(
              tap(() => {
                this.alertService.triggerAlert(error, "error");
              }),
              map(() => avatarUpdateFailure({ error })) // Dispatch 
            )
          )
        );
      })
    )
  );


  avatarDeletion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(avatarDeletion),
      exhaustMap( () => {

        const url = "profile-avatar";
        return this.crudService.deleteData(url).pipe(
          map((response) => {
            this.alertService.triggerAlert(response.message, "success");
            const user = response.data;
            this.authenticationService.pushUserData(user);
            return avatarDeletionSuccess({user: user});
          }),

          catchError((error) =>
            of(error).pipe(
              tap(() => {
                this.alertService.triggerAlert(error, "error");
              }),
              map(() => avatarUpdateFailure({ error })) // Dispatch 
            )
          )
        );
      })
    )
  );

  constructor(
    @Inject(Actions) private actions$: Actions,
    private crudService: CrudServerService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    public helperService: HelperService
  ) { }

}